import { render } from "./SetupKelasPercobaan.vue?vue&type=template&id=0bc873ac"
import script from "./SetupKelasPercobaan.vue?vue&type=script&lang=js"
export * from "./SetupKelasPercobaan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__